export const createChatStatusRepository = (appFetch) => {
    return {
        get(options) {
            return appFetch.get('/ru/include/chat_status.csv', options);
        },
    };
};
